import { createContext, useContext } from 'react';

const WorkspaceContext = createContext();

export const useWorkspaceContext = () => useContext(WorkspaceContext);
export default WorkspaceContext;
